import { PATH } from '../Constants/paths';

export const BILLING_REACTIVATED_QUERY = 'billing=reactivated';
export const REACTIVATION_POLL_MS = 2000;
export const REACTIVATION_MAX_ATTEMPTS = 30;

export function isBillingReactivatedReturn(search: string): boolean {
  const value = new URLSearchParams(search).get('billing');
  return value === 'reactivated' || value === 'setup';
}

/** Build `/subscription-inactive` path, preserving an optional query string. */
export function subscriptionInactivePath(search = ''): string {
  if (!search) {
    return PATH.SUBSCRIPTION_INACTIVE;
  }
  return `${PATH.SUBSCRIPTION_INACTIVE}${search.startsWith('?') ? search : `?${search}`}`;
}

export const STRIPE_REACTIVATION_RETURN_PATH = subscriptionInactivePath(
  `?${BILLING_REACTIVATED_QUERY}`
);
